import { NmpCertificatesResponse } from '@arianee/arn-types';

export class ArnNftCache<P = string, R = NmpCertificatesResponse[]> {
  protected readonly payloadToResults = new Map<string, R>();

  get(payload: P): R | undefined {
    const key = JSON.stringify(payload);
    return this.payloadToResults.get(key);
  }

  set(payload: P, result: R) {
    const key = JSON.stringify(payload);
    return this.payloadToResults.set(key, result);
  }

  /**
   * Clear the cache.
   */
  invalidate() {
    this.payloadToResults.clear();
  }
}
